var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffd520",
    d: "M.7 0H54v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff4e12",
    d: "M.7 40H54V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M29.4 12.5q-.5-.2-.5.5t.6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M29.7 11.7q-.4-.3-.6.3t.3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M30.2 11q-.3-.5-.7.1t.3.7zm-.3 3.7q-.6.4-.2 1 .5.7 1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M29.4 13.5q-.6 0-.8.9c0 .6-.9.8-.4 1.7q.2-1 .8-1 .5.1.9-.4zm1.2 2.3q-.6.3-.1 1.2c.2.3 1.1.2 1-.1zm1.3 3.6c0-.3-.6-.5-.9-.4q-.6.1-1-.4-.1.5.5.7.4.3.2.5c.3 0 1 0 1.2-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M31.6 17q-.7-.2-.9.4c-.2.4-1-.2-1.3.4.4-.2.7.2 1 .3.4.3 1.3.2 1.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M31.8 17.5q-.6.5-.6 1 .1.6.8.9c.3-.5.4-1.5-.2-2Zm-1.8 2q0-.2.4-.1.4 0 .3.4zm-2.4-.8q0-.5.7-.4.5.4.3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.6 19q0-.2.8-.2.7.3.6.8zm-1-.3q.2-.4-.2-.7c-.4-.2-.2-.8-.5-1q-.5 0-.6-.4-.1.4.2.7c.2.1-.2.8 0 1zm-5.8-.2q-.6-.4-1 0-.3.4 0 .8zM23 18q-.4-.6-1-.4-.5.3-.3 1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M21.8 18.5q-.6-.4-1 0-.3.4 0 .8zm0 0q-.2-.6.3-1 .6-.1 1 .5zm6.8.5q0-.2.8-.2.7.3.6.8zm-1-.3q.2-.4-.2-.7c-.4-.2-.2-.8-.5-1q-.5 0-.6-.4-.1.4.2.7c.2.1-.2.8 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M24 18q0-.9-.7-1.1-.6 0-1-.5 0 .5.4.7c.3.2 0 .7.4 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M23.9 18q-.2-.6.5-.7t.4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M24.7 18q0-.6.6-.6.7.1.3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M25.6 18.1q0-.6.6-.5t.3.7zm-6.5 5c-.7 0-.9 0-1 .8-.1 1 1.1 1 1-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M19.4 22c-1-.4-1.7 1.4-2.8 1 .4.7 1.4 0 1.7.1.6.1 2 0 1.1-1Zm-.7 2.4c-.5-.2-1.1.6-1 1s1.4 0 1-1Zm-2.5 3.7q.5 0 .6.8c-.1.6-1.2 1.8-2.2 1.8s-1.3 1.3-2.2 1c.8-.2.8-1.1 1.4-1.4-.4-.2-.6.9-1.2.9s-.9.9-1.6.8-.8 1.1-2.2 1.2c-1 0-2.4 1.2-2.9.7q1.3-.3 2.1-1.4c1-1 2.2-.6 2.5-1.5q-.7.5-1.5.5c-.7 0-1.4 1-2.1.6q.5 0 1.1-.7c.5-.5 1.2-.2 1.7-.7.9-.8 1.6-.1 2.4-1q-.4-.2-1.2.1c-.4.2-1-.2-1.5.1 0-.6 1.3-.2 2-.7.8-.5 1.5-.3 2.2-.3-1 0-1.3-.9-2.6-.6-.5.1-1-.8-1.5-.3q.1-.7 1.2-.3c.6.3.8-.3 2 .5.5.3 1.4-.2 1.9.1q-.1-.3-.7-.3c.2-.5 1.6-.4 2.3 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.1 27.4c-.5-.4-1.1 0-1.6-.1q0 .5.7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.9 26.3c-.8-.4-1 .6-1.5.4q0 .5.7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M18.3 25.5c-1-.5-1.2.6-1.9.4q.5.6 1.6.4zm1.5-4.6q-.6-.5-1 .4 0 1 .6 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M20.5 19.6q-.9-.2-1 .4c-.2 0-.2.7.3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M20.9 19.3q-.8-.8-1.4-.4c-.6.5-1.1.2-1.1.7.3-.3.6 0 .9 0 .3-.2.5.4 1.3.1zm-1.2 8.6c0 .2.5.2.7 0 .3-.3 0-1.2-.5-1.3-.4 0-.5 1-.2 1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M19.2 28c.6.2 1-.4.6-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.6 28.9c-.1.3-.8.4-1.5 1.6-.8 1.2-1.5.7-1.7 1.5 1-.7 1.6-.2 2.2-1 .8-1 1.5-.9 1.8-1.6.4-1 2.4-1 2.5-2.7-.7-.1-2.8 1.7-3.3 2.2m17-16.3c.8.3.8 1.4 1.8 1.8 1 .3 1.1 1.2 2 1-.8-.2-.8-1-1.6-1.3-.9-.2-1.2-1.6-2-1.8m3.7 6.1q.3.7-.4 1.2.5.2 1-.4-.5 1.3.4 1.6c-.3-.5.3-.8.1-1.2q.7.4.7 1c.4-.5-.4-1.2-.2-1.7zM31.9 24c-.5-.5-.7 0-1-.1q-.4-.3-.7 0c.5 0 .3.3 1.1.4-.8 0-.7 1-1.3 1 .6.6 1-.5 1.5-.3-.2 0 .2.4 0 .8.4 0 .6-.6.6-.9zm-11.6 5q-.4-.4-1-.1-.1.1.2.2c.3 0 .6.4 0 .4-.2 0-.1.6-.7.7.2.3.9 0 1-.2 0 .2.4.4.2.7.4 0 .2-.8.8-.7-.2 0-.1.6.3.4q-.2.4.2.4-.3.1 0 .5c.3-.4 0-1.7-1-2.3m23.4-12a1.5 1.5 0 1 0 .2-3 1.5 1.5 0 0 0-.2 3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M33.6 12.6c.8.3.8 1.4 1.8 1.8 1 .3 1.1 1.2 2 1-.8-.2-.8-1-1.6-1.3-.9-.2-1.2-1.6-2-1.8M16.6 28.8c-.1.4-.8.5-1.5 1.7-.8 1.2-1.5.7-1.7 1.5 1-.7 1.6-.2 2.2-1 .8-1 1.5-.9 1.8-1.6.4-1 2.4-1 2.5-2.7-.7-.1-2.8 1.7-3.3 2.2Zm20.9-10.4q.3.7-.4 1.2.5.2 1-.4-.5 1.3.4 1.6c-.3-.5.3-.8.1-1.2q.7.4.7 1c.4-.5-.4-1.2-.2-1.7zM31.9 24c-.5-.5-.7 0-1-.1q-.4-.3-.7 0c.5 0 .3.3 1.1.4-.8 0-.7 1-1.3 1 .6.6 1-.5 1.5-.3-.2 0 .2.4 0 .8.4 0 .6-.6.6-.9zm-11.6 5q-.4-.4-1-.1-.1.1.2.2c.3 0 .6.4 0 .4-.2 0-.1.6-.7.7.2.3.9 0 1-.2 0 .2.4.4.2.7.4 0 .2-.8.8-.7-.2 0-.1.6.3.4q-.2.4.2.4-.3.1 0 .5c.3-.4 0-1.7-1-2.3Zm23.4-12a1.5 1.5 0 1 0 .2-3 1.5 1.5 0 0 0-.2 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M36 19q.7-.8 1.6-.4c.4.3 2 .7 2.8.2q1-.9 1.5-.8.3.6 1 .6.2.3.7.2.5.2 1-.4.9 0 1.3-.8.7-.3.2-1.1c-.3 0 0-1.2-1.2-1 .5.3 0 1 .5 1.2q-.6 0-.7.6l-.1-.6c0-.2-.6-.8-1-.6.3 0 0 .6.3.9l-.5.3q-.3-.4-1-.6v-.3l-.2-1-.6 1c-.4-.3-1.4.1-1.9.2s-2-.1-2.4-.5q-.7-.6-1.7-.8c-1-.3-1-1.3-2-2A17 17 0 0 0 36 19Zm-10.6 9.4a1.4 1.4 0 1 0 0-2.9 1.4 1.4 0 0 0 0 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22 27.3q.6.5 1 .3.4.6 1 .7c.2.3 1 .3 1.2.1q-.4 0-.7-.4c-.4-.2-.2-.8-.5-1l.2-.7.4-.4q.5 0 .8-.3l.9.2c0-.7-.7-1-1.1-.8h-.8l-.7.3q.3-.1.2-.6l.4-.5h.8q-.5-.6-1.2-.5t-.8.7q-.4.5-.3 1l-.4.2-.7-.1m0-.6.2-.8q.2-.7-.5-.6 0 .8.4 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M22 27.3q.6.5 1 .3.4.6 1 .7c.2.3 1 .3 1.2.1q-.4 0-.7-.4c-.4-.2-.2-.8-.5-1l.2-.7.4-.4q.5 0 .8-.3l.9.2c0-.7-.7-1-1.1-.8h-.8l-.7.3q.3-.1.2-.6l.4-.5h.8q-.5-.6-1.2-.5t-.8.7q-.4.5-.3 1l-.4.2-.7-.1m0-.6.2-.8q.2-.7-.5-.6 0 .8.4 1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M21.4 23.5c.1.2.6.2.6-.2q0-.7-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M21.5 22.8q.3.2.7-.2.3-.6-.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M21.8 22c0 .2.5.6.8.3q.5-.6-.2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M22.4 21.3c.1.3.4.8 1 .6s.3-1 0-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M23.5 20.8c0 .2 0 .9.7.9.8 0 .6-1 .4-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M24.6 20.7c0 .2-.3 1.4 1.2 1 .2 0 .7-1.1-1.2-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M25.4 20.8c-.1.1.3 1.3 1.3 1.1s.1-1.3-1.3-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M26.3 21c-.2.3 0 1.3 1.3 1.3 1.1 0 0-1.3-1.3-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.3 21.3c-.1.1-.2 1.2 1.3 1.3 1 0 .8-1.5-1.3-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M28.8 21.7c-.1.3-.3 1.1 1.3 1.2 1 0 .4-1.2-1.3-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M30.2 22q-.3.6.5 1c.8.2.9-.6.4-.9l-1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M31 22c-.3.4-.2 1.1 1 1.1.2 0 1.1-.9-1-1Zm-9 14a1.7 1.7 0 1 0 0-3.3 1.7 1.7 0 0 0 0 3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m34.3 11.8-.4.7c-.6 1.6 1 2.9 1.8 4.7a5 5 0 0 1-.5 5c-.3.5-.2.7-.7 1.2q-.4.2-.3 1 .5.1.8.5h.6q.6-.2 1 .3.4 0 .9.3.2-.4.6-.3.1-.7.7-.5a.6.6 0 0 1 .8-.8q.8-.5 1.6.1c-.7-.1-.7.6-1.3.5q.2.6-.6.8.5-.2.6 0 .5-.4.8-.1.4 0 .7.3.7.6.3 1.3c0-.5-.4-.4-.5-.6l-.7-.1q-.4.3-1 0-.2.7-.8.8 0 .6-.5 1 .5.4.2 1c.6 0 .1.5 1 .8-.4.2-1.3 0-1.4-.6q-.8-.1-.8-1-.6-.6 0-1.1c-.4 0-.6-.6-1.2-.3-.3.1-1.1-.1-1.1-.4-.2.2-1 .1-1-.2-.3.1-1-.1-1-.5q-.5.2-.7-.5-.4-.1-.3-.5-.4-.2 0-.7-.4-.3 0-.8-.3-.3-.2-.8c-1 0-2.3-.3-5.2-1.2-4.5-1.4-5.7 1.8-4.7 3.8 1.1 2.4-.1 2.9.2 4.6q.8.1.6.8.5 0 .4.7l.6.1q.4-.4 1 0 .8 0 .7 1a2 2 0 0 1-.1 1.6V33c0-.4-.5-.5-.5-.8q-.4 0-.6-.3l-.5.1q.5.4.4 1 .2.6 0 1-.2.6-.9.3.4-.2.3-.6l-.2-.5q-.8-.1-1.1-.5a2 2 0 0 0-1.7 1.7l-.4-1q-.4-1.2 1.2-1.6c-.2-.3.3-.7.1-1l-1.2-1.7q.4-1 0-2-.2-1-1.7.7c-1.7 2-4.1 1.4-6.2 2.7-.6.3-1.1.5-.5-.1s2.1-1.2 3.2-1.7c2-1 3.5-2.6 4.2-5.7 1.5-7.4 7-5 10.6-3.6 3.3 1.3 2.7-1.6 1-3.4-2-2.1-1.6-3.8-.6-5.1 1.6-.2 4.9.3 4.2 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M40.3 29.9a1.8 1.8 0 1 0 0-3.7 1.8 1.8 0 0 0 0 3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M33.3 11.9c-.4 1.8 0 2.6.6 3.4 1.2 1.6 2.2 5.4.8 7.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M35.5 21q.3 0 .5-.6m-.4-.2c0-.3.5-.4.5-.7m-.5-.5c0-.3.5-.6.4-.9m-.7-.2c0-.2.5-.5.3-.8m-.6-.4c-.1-.2.2-.4 0-.6m-.5-.3v-.6m-.6-.4q.2 0 .2-.4m-.5-.4q.2 0 .2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M22.8 34.2q-.8-.1-1 .5m.3.3c0-.4.6-.5.8-.4-.4-.1-.6.5-.2.6m2.8-8.7q-.4.3 0 1m.4-.9q-.2.4.1.7-.2-.3.2-.4.4 0 0 .4m14.8.4c-.6-.2-1 .5-.5 1.1q0-1 1-.9m-.3.5a.2.2 0 0 0-.3.2q0 .2.3.2l.2-.2m1.9-13.4q.2.6 1 .4m0-.2q-.5-.1-.6-.5c0 .1.5.2.6.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "m23 27.6.3-.6q0-.4.7 0m-.1-2.3-.3.1m1 1.1h-.4m0 .4-.3.1m-3.4 6.4.3.6m.6-1-.1.6m1.7 0q-.2-.3-.1-.7 0-.5.7-.3m-2.4-.2h.5m2-.7-.2.4m1-.4-.3.2m-1.8-5.7c.2 0 .7.4.7.6m1.2-2c-.6 0-.8-.5-.4-.5m1.3 1.3q-.3.1.2.6m-1.5 2.7q-.1-.4.4-.4m.4 4.3c0-.3.5-.5.6-.1m-2.1 1q0-.4.3-.4t.5.3m-4 .4q0-.3.4-.4m19.3-9c-.2 0-.3.5.2.5m-1 .2v.1m2.5.7q-.5.1-.2.7m-3.3 3q.1-.6.5-.4M37.3 27l.5-.3m-.6 1.4.2-.5m.7-2.4.2.8m2.4-.8-.4.2m.2.7.2-.2m3.9-9.2q-.1.5-.7.3m1.5-.3c.1.2.7 0 .6-.3m-1.3 2-.4-.2m1.6-.6h-.5m-2.6 1 .5-.1m-.8-1.8-.3.1m2.5.5-.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M42.1 17.7c.3 0 .6.8 1.3.5m0-1-.1.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m30.6 15.9.3-.2M19.5 26q.6.2.5 1m14.3-12h.7m.2.2c0 .1 0 .7-.2.8m0 0q.6.1 1-.5m-.3.4q.3.5-.3.9m.4-.5c.3 0 1 .1 1-.5m-.3.5c.2.3 1.1.6 1 0m-1.9.9q.8 0 .7-.9m1 .4c0 .2 1.3.5 1.1 0m-.2.2c.2.6 1.4.5 1-.2m-.2.6c.3.3 1.3 0 .9-.6m0 .5c.6.5 1.4-.2.6-.7m.4.6c.5.4 1.3-.4.7-.6m-5.3.4q.4 0 .6-.3m-.1.2c0 .5.8.7 1 .1m-.3.3c.2.4.9.5 1 0m-.1.3c.1.3.7.2 1-.1m-.3.2c.2.4 1 .4 1.1-.2m0 .3c.2.2.9.1.8-.5m-.1.4c.5.4 1.1 0 .8-.6m0 1.1c.2 0 .3-.5 0-.6M36 18q.8-.5.2-1.2m.2.8c.3.1 1 0 1-.5m-.6.5q.3.3 0 .8m.2-.5c.5-.4 1.3.3.7.7m0-.7.3-.6m-.1.8c.2-.2 1.8.3.8.8m0-1.5q.5.4 0 .8m.3.3c.4-.3 1.5-.1 1 .3m-.2-.4c.2-.7 1.4-.3 1 0m-1.2-.7-.2.6m1.1-.7v.4m.8-.4v.5M32 12.8q-.1 1 1 .6m-.7 0c-.5.6 0 1.2.8.6m-2.1-.2c.5.5 1.5.1.9-.8m.7 1.3q0 .9.7.4m-2.8-.8c0 .5.7 1 1.3.7m-.6 0c0 1 1.2 1 1.5.1m-.5.6c.4.7 1.2.4 1.5 0M31.5 14q.2.8 1.2.5m-3.3-.7q.1.8 1.3.3m-1 .2c-.3.4.4 1 1.2.2m-.7.4c.1.7.4 1.2 1.4.3m-.5.4q.7.9 1.4 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M33 15.7q-.1.9.4.8t.9-.5m-1 .5c0 .6.5 1.1 1.4.5m-1 .2c-.1.5.4 1.3 1.4.9m-3.5-2c0 .5.5.9 1.4.1m-1 .5c0 .4.6 1 1.4.2m-1 .4q.2 1.3 1.4.4m-2.5-1 .4-.3m0 .9.4-.3m0 1.2c0 .2.7.1.7-.1m-.1.1c.3.8 1.1.8 1.5 0m-.2.2q.3.8 1.3.6m-1-.1c-.3.6.2 1.3 1 .6m-.7.3q0 .7.7.8m-2.3-2c-.2 1 .5 1.3 1.2.9M32 19h1m.4.5c-.2.8.5 1.3 1.2.5m-2.3-1q0 .8 1 .8m1.8.7q-.7.5.1 1.1m-1.1-1.2q0 .6.7.7m-1.4-1c-.6.6 0 1.3.8.7m-.3.2c-.2.7.6 1 1 .4m-2.4-1.8q-.2 1 .7 1m-1.5-1.2q.1.6.8.5m-.6 0q-.2.8.8.6m1.7 1.3q-.1.5.5.7m-.4-.2c-.7.2-.7.9-.2 1.2m-.3-2a.6.6 0 0 0 0 1m-2.9-2.9c-.3.4 0 1.4.8.8m1.3.5c-.5.4-.2 1.1.6 1m-1.4-1.3q-.3 1 .6 1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M30.6 19.7a1 1 0 0 0-.1 1q.4.3.6-.2m-1.4-1.1c-.5.6 0 1.4.7 1.2m2 .7q-1 .3-.7 1c.2.2 1 .3 1.3-.6m-1.6-1q-.5.7.4 1m-.4-.2q-.5.1-.5.7m-.2-1.4q-.2.7.3 1m-.3-.4q-.8 0-.6.7m0-.6q-.6-.3-.3-1m0 .6q-.9 0-.8.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M29 19.1q-.5.4-.3 1 .3.4.8.1M28 18.7c-.3.4 0 1.2.7 1M27 18.4c-.3.5 0 1.2.9 1m0 2.1c0-.5.5-.9 1.2-.2m-.3-1-.3.6m-2.4-2.7q-.4 1 .9 1m1.1.5q-.6.8 0 1.3m-.3-.7c-.8 0-.8.9-.2 1.1m-.4-2q-.6.5.1 1m-.1.3q-.6-.2-.7.4m.2-.4c-.3-.7-1.1-.6-1 .2m1.3-1q-.4 0-.7.4m0-1.2a.6.6 0 0 0 .2 1M25.4 18q-.1.8.7.6m-.5 0q-.3.8.7.8m-.6-.1q-.3.6.3 1m-.4-.5q-1 .2-.5 1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M25 18q-.5.3-.3.9.4.4.8 0m-.7.1q-.3.7.3 1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M23.6 17.9q-.3.6.5.8.8-.1.6-.8m-.7.8q-.3.8.7.8m.3.7c-.4-.2-1 0-.8.5m0-1.3q-.3.5 0 .9m0-.2q-.7 0-.5.7m0-.4c-.4-.1-1 .2-.6.6m0-.4q-.8 0-.5.6m-.1-.2q-.6.1-.4.6m1.9-2.3q-.6.4-.3 1m-.2-2c-.6.3-.6 1.2.1 1.5m-.3-.2q-.5.4-.2.9m-.5-2.4c-.2 0-.2.8.5.8m-1.2-.6c-.5.4.1 1.2 1 .6m-.5.2q-.1.7.6.8m-.6-.3c-.4.2-.4 1 .3 1M21 19c-.5.4.5.9.8.2m-1.5.5c-.2.4.7 1.2 1-.2m.2 0q0 .5.6.5m0 .3c-.7.1-.9 1-.2 1.1m-1-1.2q0 .6.6.5m.3.7c-.5.1-.6.9 0 .8m-.4.7q-.7-.4 0-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M21.1 22.3q-.4.6 0 1 .4 0 .4-.3m0 .9c0 .2-1 .1-.5-.7m0 .7c-.3.6.2 1 .6.5m-.5.2c-.2.4.4.7.7.4m-1.9-4.6c-.2.4.8.6.9-.2m-1.2.8c-.1.8 1.3.6 1-.4m0 .6a.7.7 0 0 0 1-.6m-.5.6.4.5m-1.1-.3q.1.7.8.7m-.7-.3c-.3.3-.3 1 .4 1m-1.6-.9c0 .4.6.7 1 .1m-1.2.8c0 .2.6.6 1-.5m-.3.5q.3.6 1 0m-.6.3q0 .7.7.6m-1.5-.7q.2 1 1 .6m-1.4-.3c-.2.6.7.9 1 .4m-.2.2q.2.7 1.1.4m-2.2 0s.7.3.8-.3m-.3.4q.4.7 1 0m-.1.2q.1.7 1 .3m.2.2c-.1.5.5 1 .8.7m-1.7-.8c-.2.6.6 1 1 .6m-2-.9q.1 1 1 .7m-1.9-.6c-.1.3.7.6 1 .3m-1.5.7c.3.2 1 0 1-.6m-.2.4q.6.6 1.1-.2m-.2.4c0 .4.8.8 1.1 0m1 0q-.2.6.5.7m-1.2-.8q0 .6.7.5m.1.1q-.2.6.4.7m-.4-.2q-.3.6.3.7m-.4-.3c-.4.3-.3.9.3.9m-1.5-2c0 .6.7.6.8.1m-.2.4q-.1.6.6.5m-.6 3.6c.2.1.6-.1.4-.3 0-.3-.5-.1-.4.1m.3-.2c0-.5-.5-.6-.6-.2m.2-.2c.1-.2-.3-.6-.5-.2m.1-.2c.2-.3-.4-.5-.4-.1m-.1-.5c0-.2.6 0 .4.3m.4.4c.3-.2-.1-.6-.4-.5m2 1.2q-.3 0-.2.5c0 .3.5.3.6.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M22.4 30.5c-.2-.1-.6 0-.4.5m0 0q.3.3.5 0m-.5 0q-.4.2-.7 0m.4-.5.3.1m-.4-2.7c-.3.2 0 .8.4.6m-.5-.1c-.2.2 0 .8.5.5m-.4 0c-.2.2 0 .7.4.6m-.5-.3-.4.1m.2-2.3q-.4.5.3.7m-.4-.2c-.4.1-.4.8.3.8m-.4 0c-.1 0 0 .7.4.6m-.2 0v.3m-.2-.6q-.3 0-.5.3m-.3-.6c0-.1.6-.1.7.4m0-.6-.2.2m0-1.8c-.2.2-.4.9.3 1m-.8.4q.2-.4.7-.1m-1-.9q.1.3.6.2m-2.3-1.2a.5.5 0 0 0 .6.5q.4-.1.3-.6m-.3.6q-.2.6.3.6m0-.8q.4-.1.7.1m-2.2 0c-.1.1.6.3.8 0m-.2.2q-.1.4.6.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M19 27.2q0-.5-.7-.1c-.3.3.1.7.3.5m-1-1.1c-.2.3.4.8.8.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.1 27q-.2.5.4.5.4-.3.3-.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M16.7 27.4q-.2.5.3.6t.3-.5m.4-.1q.1.4.6.2m0-.5V27m-2 .8c-.2.2.3.7.5.3m1.1-.3c-.1 0 .1.4.3.3m-1-.1q.2.4.8 0m-.6.2q0 .4.3.4m4 1c-.1.3.4.7.8.3m-.4.1q0 .4.2.6m-.7-.2q.1-.3.5-.2m-.8-.2q0-.3.4-.3m12.5-5.4c-.7.2-1-1-.2-1q-.8 0-.9-.4m.6 1.3q-.1.5.5.4m-.1 0c-.2.4.6 1 .9.4m-.3.2c0 .4 1 .6 1-.1m-.2.4c.3.4 1.2.4 1.1-.2m-.2.4c.2.3 1 .5 1 0M32.8 22q.4.6 1 .3m-1.2 0c.3.2-.2 1-.6.7m.6-.2q.6.3.8-.4m-1 .6c.4.4-.2 1.1-.5.8m.6-.5q.6.2.8-.4m-.2.4q0 .3.5.3m-1.2 0q.5.5 1 0m-.2.3q0 .4.6.4m-1.8.2q.6 0 .4-.8m0 1.3q.4-.1 0-.7m.7 1.2c.3 0 .2-.7-.5-.7M34 26c.2-.1 0-.8-.7-.8m1.7 1c.1-.3-.4-.8-1-.5m1.5.9c.3 0 .5-.8-.5-.7m1 .7c.4-.1.6-.6-.3-.5m1 .5c.3.2.4-.6-.4-.4m-3.9-2q.6.3.8-.4m-.1.4q0 .4-.2.7m.2-.3q.4.1.7-.3m-.3.3v.6m0-.3q.5.2.6-.3m-.1.2q.4.3 0 .8m.2-.2q.4 0 .7-.2m-.1.1.3.6m0 0q.4-.1.6-.5m0 .2.2.5m0-.2q.3 0 .5-.3m-.1.2q.2 0 .3.4m0-.2q.3 0 .4-.2m.4 0c.2.2 0 .8-.5.7m-3.6-13.8c-.4.3-1.6.2-1-.7m1 .1c-.7.3-1.7-.3-.7-1m-.2-.1c-.7 0-1.1 1-.3 1.4m-2.3-1c-.1.3.5.7.9.4q.4-.7 0-1.3m-1.2 1.7c-.2.7 1.4.7 1.1-.4m-1.2 1.4c0 .6 1.5.4 1-.7m.2-.3q.1.4 1 .4m-.7-1.1q0 .3.7.2M16.1 27.9c-.4.3.2.7.4.2m-.7 0c-.3.3.2.7.4.2m-.7 0c-.3.3.2.7.4.2m-.7 0c-.4.2 0 .6.4.2m-.7 0c-.4.2 0 .6.4.2m1.3-.8c0 .3.6.4.8 0m-.4.3q-.1.4.3.3m-1-.4q.1.5.6.1m-.4.2q0 .3.4.3m-1-.4q.2.4.6.3m-.4 0 .1.4m-.6-.4q0 .3.5.2m-.5 0q-.2.1.1.3m-.5-.4q0 .3.3.3m-1.2-.3c-.2.1.3.6.6.2m-1 0c-.2.1.3.6.5.1m.9-.1q-.3.1-.2.4m-.4-.3.4.2m-.5-.2q-.2.3.1.4m-.7-.2q-.1.3.2.3m.1-.3.3.1m-1-.2c-.3 0-.3.6.4.3m-1-.1c-.2.1 0 .5.5.1m0 0q-.1.2.2.3m-.6-.1q-.2.2.1.2m-.7-.2q-.1.3.5 0m-.4.1q0 .3.2.3M12 30q-.3.2.5 0m-.4 0q-.2.4.1.3m-.5-.1q-.2.2.4 0m-.4.1q-.4.4 0 .3m9.5.5q0 .3.3.3.4 0 .3-.4m0 .2q.4.2.5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M33.7 8.6c-.8-.4-2.6-1.2-3.1-.6.4-.2 1.8 0 3 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34.3 8.5c-1-1.1-1.6-.9-2.3-1.2-.7-.4-1.8-.5-2 0 1-.4 1.9.3 2.5.4q1 .4 1.4 1zm3.7-.1c-.5-1.2-1.6-.9-2.1-1.4-.7-.7-2.5-1.4-3.3-.9 1.7 0 2.4 1.1 3.2 1.6.7.3 1.3 1 2.2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M36 8.3c-.8-1.1-2.2-2-2.8-1.7.8 0 1 .6 1.7 1 .5.3.3.8 1.2.7Zm-4 1.9c-1-.3-2.7-.5-3.6.5 1.4.3 3.5.1 3.6-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M31.7 10.6c-1-.4-1.6.2-2.5 0q-2.6-.2-3 .8c1-.8 2.5-.1 3.2-.3.6-.2 3 0 3.8.3q-.7-.6-1.5-.8Zm2.9-2.5c-.2-.7-.2-1.4.9-1.4-.3-.3-1.3-.5-1.5.8-1.1-.9-2.4-1-2.6-.3q1-.7 2.6 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M33 9.1c-.7-.4-1.6-1.1 0-1.4-.7-.3-1.7-.2-1.6 1q-2.8-.9-3.3.3c-.3.8.8 1.2 1 .7-.2.1-1-.1-.6-.6s2.3 0 4 .8c.6.3 2.3.3.5-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M32.5 10.3c-.5-1-2.2 0-2.5-1.1-.5 1.5 2.4.7 2.5 1.1Zm10.6 1.1q.8.2.1-.3.8.2.1-.3.8.2.2-.3zm.2-2c.8-.8 0-1 .9-2 .8-.6.1-1 .8-1.6q.6-.3.9-.8c.3.7-1 .8-1 2 .1.9-.4.8-.6 2.1 0 .3-.3 1-1 .3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M43.6 9.8c.5-1 1-1 1.2-1.3.5-.7 1.4.1 2.2-.5-.1.9-1.2.6-1.7 1.1q-.5 1-1.7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M43.7 10c.8-.5 1.3-.1 1.9-.4 1.3-.8 1.8.1 3-.2-.3.7-2 0-2.8.6s-3.4 1.1-2 0Zm-2.1 4.4q-.1-.7-.8-.9c-.5 0-.7-.5-1-.5s-.6-.7-1-.7-.7.6.4 1.2c1 .5 2.3 1.2 2.4.9Zm-1.4.3c-.5 0-.6.7-1 .7.6.3 1-.2 1.4-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M40.6 14.8c-.5.3-.6 1 0 1.2-.3-.5.6-.7.3-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M41 14.8c-.4.6.5.7.2 1.1.5 0 .6-1 .2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M37.8 13.4q1.2 0 2 1c.3.5 1.3.7 1.6.3s.2-1-.7-.8c-.2-.3-.8-.2-1.1-.5s-1.5-1.2-1.8 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.7 14q-.3.1-.1.5Zm.4.1v.4Zm-2-.6.8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M40.7 14q-.3.1-.1.5m.5-.4v.4m-2-1 .8.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M38.8 12.5q1.5.3 3 1 1.3.6 2.7.3c1-.3 2.7-.5 2.6.6q.6-1-1.3-1.3-.2-1-1-.7c.4 0 .7.7 0 1a.7.7 0 0 0-1-.8c.3 0 .7.7-.1 1q-1 0-1.9-.5c-.6-.3-3.7-1.5-3-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M42.2 12c-.4.1-.1.6-.8.8q-1.1.6-1 1.4c.5-1 1.3-1 1.6-1.3.2-.4.6-1 .2-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M42.3 12c0 .8-.6.5-.4 1.6q.3.5 0 1.5c.7-.5.3-1.6.6-2l.4-.7c-.2.4-.1 1.2.3 1.4-.4-.8 1-1.5 0-2.5q-.2.6-.9.7Zm-2.1-.8q.1.4 0 .8.5-.2.7-.7c.4 0 .6.6.2.9q.4 0 1-.3c-.4-.3-1.3-.9-2-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m33.5 9.7-.4-.2c-.7-.1-.3-.7.2-.7 1.2-1.3 1.9-.3 3.3-.7q.8-.2 1.1 0 1-.6 2 .2l.2-.2q.9 0 1 .8.8 0 1.2.4.6-.3.8 0 .6-.3 1 .3c.3.6-.5.5-.6 1.7 0 .7-1 1-1.6.6-1-.7-2.1-.9-2.6.2q-.6 1.8-2.2 1.4a1 1 0 0 0-1.4.5c-.3.5-.9 0-1.6.1.9-.1.6-.3 1.3-.4.6 0 .5-.6.9-.7-1.7.4-1.6-.2-3 .2.6-.7 1.6-.3 2-.8-1.2 0-1.8-.8-2.3-.5-.9.6-.5 2.1-2.8 2q-1.6-.2-2.5.7c1.2-2.4 2.7-1 3.5-1.8l1-1.2.4-.3c-2-.6-.8-1.6 1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43 9.3v.3c0 .5-.8.5-.8 1.2q0 .5-.3.5-.5 0-.2-.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M43 9.3v.3c0 .5-.8.5-.8 1.2q0 .5-.3.5-.5 0-.2-.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m33.8 9-.5-.2Zm4-.9q.6.6 1.6.9c.8 0 1.3 1.2 2.6.4h.1m-2.4-1-.2.6ZM37 10.6q-1.4.2-1.3 1c0 .5.5 1.2 1.3 1.2q1.3-.1 1.3-1 0-1.1-1.3-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m33.8 9-.5-.2m4.4-.7c.6.3.9.8 1.7.9s1.3 1.2 2.6.4h.1m-2.4-1-.2.6m-2.4 1.7q-1.4.2-1.3 1c0 .5.5 1.2 1.3 1.2q1.3-.1 1.3-1 0-1.1-1.3-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.3 12.9c0-.3-.6-.3-.5-.5l.2-.6c0-.3.5-.3.6 0q.4.5.7.4m-.7-.5a1 1 0 0 0 0 1.1m.4-.7v.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M37.3 12.9c0-.3-.6-.3-.5-.5l.2-.6c0-.3.5-.3.6 0m0 0q.4.5.7.4m-.7-.5a1 1 0 0 0 0 1.1m.4-.7v.6m4-1.4c.8 0 .9-.8.3-.9M41 9c-.3-.4-1-.5-1 .2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40 10c-.3-.6-1-.7-1.3-.4s-.3 1 .3 1.2zm-.3-.4c-.4-.3-1 .4-.4 1Zm-7.4 1.7 1.3.3c.3.2 1.4.6 2.1.2-.7.2-1.2-.8-1.8-.7-.5.1-1.5.3-1.9 0 1 0 1.5-.8 2.7-.1q.5.3 1.1.3c-1-1.1-2.2-.4-2.3-1.3.5.6 2-.2 2.6 1m-2.4-.9-.2-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M39.7 9.6c-.4-.3-1 .4-.4 1m-7 .7 1.3.3c.3.2 1.4.6 2.1.2-.7.2-1.2-.8-1.8-.7-.5.1-1.5.3-1.9 0 1 0 1.5-.8 2.7-.1q.5.3 1.1.3c-1-1.1-2.2-.4-2.3-1.3.5.6 2-.2 2.6 1m-2.4-.9-.2-.4m6.5.4c-.3-.7-1-.8-1.3-.5s-.3 1 .3 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41 9c-.2-.3-.8-.1-.6.4zm-1.5 1.3.5-.2-.3-.5c-.1 0-.5.4-.2.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M38.9 9.5q-.6-.5-.9 0-.4 0-.5.5m.6.2q-.9-.5-1 .5m-.3.4q.3-.4.8 0m2.6-.7v.6q-.4-.4-1 .4m2-1q-.8.2 0 .6m-4-2c-.4 0-.7.2 0 .4m1-.7q-1.1-.2-.7.2m-1.2 2.5q-.1.5.5.2m-.4.5v.2m-1.6-3.4c-.4 0-.4-.5 0-.4m-.1 1.3c-.5-.1-.5-.6 0-.5m.8.3c-.5-.1-.5-.5-.1-.4m.2-.7c-.3 0-.7.3 0 .4m.8.2q-1 0-.3.3m.8-1q-.8.1-.4.4m-1.2 1.5c-.1 0-.2-.6.4-.4m.8.3q-.8 0-.4.5m1-1q-.8 0-.6.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m41 9-.6.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m41 9-.6.4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBt);
export default __webpack_public_path__ + "static/media/bt.f194b6547be02be5cf796447a0c36c42.svg";
export { ForwardRef as ReactComponent };